import HelpIcon from './HelpIcon'

export default HelpIcon
